<template lang="pug">
  .bosnia-and-herzegovina
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/bosnia-min.png"
      )
      span {{ gettext('Босния и Герцеговина') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content.one-grid
      div
        p {{ gettext('Этот народ проживает в маленькой стране на Балканском полуострове, которая называется Босния и Герцеговина. На данный момент страна является потенциальным кандидатом в ЕС по текущей программе расширения, это значит, что граждане страны все еще нуждаются в разрешениях на работу и пребывание.') }}
        p {{ gettext('Фактически, население страны представлено тремя нациями, отличающихся друг от друга по религиозных и языковых признаках. До недавнего времени народу Боснии и Герцеговины удавалось прожить в полном понимании, терпимости и лояльности, но сейчас ситуация изменилась. После определенных сложных политических событий многие люди остались без работы, экономика страны значительно пострадала и не может в достаточных мерах прокормить свою нацию. Конечно, с тех пор виден прогрессивный рост и развитие, дома отстраиваются, создаются новые рабочие места и предприятия, но для восстановления стабильности нужно время. Все население Боснии и Герцеговины хочет видеть свою страну процветающей, и, несмотря на общий негатив, эти нации сохранили в себе много положительных черт – открытость, доброжелательность, гостеприимность, оптимизм, стойкость, сдержанность, ответственность и трудолюбие.') }}
        p {{ gettext('Многие жители Боснии и Герцеговины отправились в более развитые страны для трудоустройства: Сербию, Черногорию, Хорватию, Словакию, Чехию, Германию, Австрию, Скандинавские страны, США и другие. По общим оценкам за последние годы, около 1,5 млн боснийцев эмигрировало за пределы Боснии и Герцеговины.') }}
        p {{ gettext('Работают выходцы из этой страны в очень разных сферах: строительства, производства, сельского хозяйства, сфере обслуживания и персональной помощи, транспорта и технологий, здравоохранения, торговли, социальных услуг и других.') }}
        p {{ gettext('Многие из них смогли подтвердить свою квалификацию и устроится на специализированную высокооплачиваемую работу – врачом, технологом, слесарем, электриком, сварщиком и т.д. Уровень образованности граждан Боснии и Герцеговины позволяет им быстро и эффективно справляться с работой, осваивать новые навыки и знания, учится и развиваться. Также стоит добавить, что все они являются высокомотивированным персоналом, который ценит свое рабочее место и готов задействовать весь свой потенциал и ум.  Подавляющее большинство жителей этой маленькой страны владеет английским или немецким языком на среднем разговорном уровне, так как изучали иностранные языки со школы. ') }}
        p {{ gettext('Работодатели, принимавшие в свой коллектив выходцев из Боснии и Герцеговины, подмечают что большинство из них очень способные, интересные, открытые и трудолюбивые люди. Они ценят свою работу, поскольку могут заработать сравнительно больше денег и поддержать свою семью. ') }}
        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/bosnia-min.png'})
  },
  name: 'BosniaAndHerzegovina',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'BosniaAndHerzegovina | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/bosnia-and-herzegovina/index.vue